import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { AutomationsListPage } from '#features/automations/automations-list-page.tsx'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/automations/',
)({
  component: AutomationsListPage,
  pendingComponent: DefaultLoader,
})
